import Skeleton from 'react-loading-skeleton'
import { range } from 'utils/arrays'

interface Props {
  count?: number
}

export function ExtendedNavSectionSkeleton({ count = 4 }: Props) {
  return (
    <div>
      <Skeleton className='w-20' />

      <div className='space-y-2.5'>
        {range(0, count).map(item => (
          <Skeleton
            key={item}
            className='h-6 w-2/3'
            containerClassName='flex items-start'
          />
        ))}
      </div>
    </div>
  )
}

export function MobileExtendedNavSectionSkeleton({ count = 4 }: Props) {
  return range(0, 4).map(i => (
    <Skeleton key={i} containerClassName='block' className='h-5 w-full' />
  ))
}
